import { useState } from 'react'
import { buildShareUrl, copyText } from '../utils/share'
import styles from './ShareButton.module.css'

interface Props {
  currentTime: number
  onShared?: (url: string) => void
}

export function ShareButton({ currentTime, onShared }: Props) {
  const [toast, setToast] = useState<string | null>(null)

  const onClick = async () => {
    const url = buildShareUrl(currentTime)
    const ok = await copyText(url)
    setToast(ok ? 'Link copied' : 'Copy failed')
    onShared?.(url)
    window.setTimeout(() => setToast(null), 1800)
  }

  return (
    <div className={styles.wrap}>
      <button type="button" className={styles.btn} onClick={() => void onClick()} aria-label="Share timestamp">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden>
          <path
            fill="currentColor"
            d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"
          />
        </svg>
      </button>
      {toast && <span className={styles.toast}>{toast}</span>}
    </div>
  )
}
